/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import InfoCircleIcon from "assets/icons/info-circle.svg?vue";
import CloseIcon from "assets/icons/menu-close.svg?vue";

function PinningDisclaimer({ compact = false, onDismiss, ...restProps }) {
  return (
    <div
      {...restProps}
      className={cn("mb-2 flex items-center gap-2 rounded-lg bg-purple-200 px-3 py-2")}
      data-testid="pinning-disclaimer"
    >
      <InfoCircleIcon
        className={cn("shrink-0 text-gray-900", {
          "size-5": compact,
          "size-6": !compact
        })}
        data-testid="shrink-0"
      />
      <span className="m-0 flex-1 text-xs leading-relaxed text-gray-900">
        {compact ? (
          <>Our design team makes edits after checkout.</>
        ) : (
          <>
            {" "}
            Our AI helps gather your instructions — but a real human artist will complete the edits
            after checkout. We'll email you a proof to approve before your shirts go to print.{" "}
          </>
        )}
      </span>
      <button
        className="shrink-0 cursor-pointer rounded border-none bg-transparent text-gray-700 hover:text-gray-900"
        type="button"
        aria-label="Dismiss disclaimer"
        data-testid="pinning-disclaimer-dismiss"
        onClick={onDismiss}
      >
        <CloseIcon
          className={cn("text-gray-700 hover:text-gray-900", {
            "size-5": compact,
            "size-6": !compact
          })}
          data-testid="text-gray-700"
        />
      </button>
    </div>
  );
}

export default PinningDisclaimer;
